<template>
	<div class="hotel-list-item-list">
		<Loading
			v-if="loading"
			class="hotel-list-item-list__loader"
		/>
		<ul
			v-else
		>
			<li
				v-for="(item, index) in items"
				:key="index"
			>
				<HotelListItem
					:item="item"
					:item-index="index"
					:show-suns="showSuns"
					:hotel-list-type="hotelListType"
					:discount="discounts?.get(getDiscountKeyForOffer(item))"
				/>
			</li>
		</ul>
	</div>
</template>

<script lang="ts" setup>
import HotelListItem from '@lmt-rpb/HotelListItem/HotelListItem.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { getUniqueKey } from '@/components/common/services/bestOfferForHotelListService';
import { ItemType } from '@/interfaces/hotel-list-types/hotel-list-types';
import { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';

const getDiscountKeyForOffer = (item: ItemType) => {
	const offerId = item.AccommodationOffer ? item.AccommodationOffer.OfferID : item.PackageOffer!.OfferID;
	const iffCode = item.Hotel.IffCode;

	return getUniqueKey({ offerId, iffCode });
};

interface Props {
	items: ItemType[],
	loading?: boolean,
	showSuns?: boolean,
	hotelListType: string,
	discounts?: Map<string, DiscountHotelPriceOffer>
}

withDefaults(defineProps<Props>(), {
	loading: true,
	showSuns: false,
	discounts: undefined
});

</script>

<style lang="scss" scoped>
.hotel-list-item-list {
	margin: 0 auto;
	container-type: inline-size;
	container-name: hotel_item_list;

	.hotel-list-item-list__loader {
		margin: 30rem auto;
	}

	ul {
		list-style: none;
		padding: 0;

		& > li:not(:last-child) {
			margin-bottom: 1.6rem;
		}
	}
}
</style>
